import { render, staticRenderFns } from "./ElectricityTab.vue?vue&type=template&id=7d12b088&"
import script from "./ElectricityTab.vue?vue&type=script&lang=js&"
export * from "./ElectricityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports